import { CmsApiRecentSalariesBlockData } from 'modules/cms/api/types/blocks/CmsApiRecentSalariesBlock';
import { CmsBlockMapping } from 'modules/cms/blocks/CmsBlockMapping';
import { CmsMappedBlockWidth } from 'modules/cms/mappers/CmsMappedBlockWidth';

import { CmsAmpRecentSalariesBlock } from './CmsAmpRecentSalariesBlock';
import { CmsRecentSalariesBlock } from './CmsRecentSalariesBlock';

export const CmsRecentSalariesMapping: CmsBlockMapping<CmsApiRecentSalariesBlockData> =
  {
    invariant: [],
    width: CmsMappedBlockWidth.FULL,
    Component: CmsRecentSalariesBlock,
    AmpComponent: CmsAmpRecentSalariesBlock,
  };
